export default "__VITE_ASSET__C_XvZBHJ__"